<template>
  <div class="d-flex flex-column justify-content-between">
    <div
      class="d-flex flex-row justify-content-center align-items-center seller-account-events-top mb-4"
    >
      <b-button-group class="mb-5 mr-4 my-auto">
        <b-button
          :class="selected_method === 'all' ? 'selected-method' : ''"
          @click="select_method('all')"
          >All</b-button
        >
        <b-button
          :class="selected_method === 'prepaid' ? 'selected-method' : ''"
          @click="select_method('prepaid')"
          >Pre-Paid</b-button
        >
        <b-button
          :class="selected_method === 'postpaid' ? 'selected-method' : ''"
          @click="select_method('postpaid')"
          >Post-Paid</b-button
        >
      </b-button-group>
    </div>
    <div>
      <invoices-list :invoices="invoicesFiltered" />
    </div>
  </div>
</template>

<script>
import InvoicesList from "../components/InvoicesList.vue";

export default {
  name: "ViewInvoices",
  components: {
    InvoicesList,
  },
  props: {
    category: String,
    categories: Object,
    invoices: Array,
    date_range: Object,
  },
  data: () => {
    return {
      charge_method: null,
      selected_category: null,
      selected_method: "all",
      start_date: "",
      end_date: "",
    };
  },
  created() {
    this.start_date = this.date_range.start_date;
    this.end_date = this.date_range.end_date;
  },
  methods: {
    categoryTitle(category) {
      const split_category = category.split("_");
      let string_category = "";
      split_category.forEach((category) => {
        string_category +=
          category.charAt(0).toUpperCase() + category.slice(1) + " ";
      });
      return string_category;
    },
    selectCategory(category) {
      this.selected_category = category;
    },
    select_method(method) {
      this.selected_method = method;
    },
    reloadInvoices() {
      this.$emit("update", this.start_date, this.end_date);
    },
  },
  computed: {
    invoicesFiltered() {
      if (this.selected_category === "all" || this.selected_category === null) {
        if (this.selected_method === "all") {
          return this.invoices;
        } else {
          return this.invoices.filter(
            (item) => item.method === this.selected_method
          );
        }
      }
      return this.invoices.filter((item) => {
        return item.category == this.selected_category;
      });
    },
    categoryFilter() {
      let filter = [];
      filter.push({ text: "All", value: "all" });
      Object.keys(this.categories).map((category) => {
        filter.push({ text: this.categoryTitle(category), value: category });
      });
      return filter;
    },
  },
};
</script>

<style scoped>
.seller-account-events-top {
  border-radius: 0.5em;
}
</style>
